import getCoordsStartEnd from "../percents/get-coords-start-end";
import getAxisValue from "./get-axis-value";
import getScrollDefaultPercents from "./get-scroll-default-percents";

/**
 * Get "default" scroll percents for "y" axis
 * @param {MainClassProps} main
 * @param {TriggerProps} trigger
 * @returns {Number}
 */
const getScrollDefault = (main, trigger) => {
  let start = 0;
  let end = 0;
  let startX = 0;
  let startY = 0;
  let endX = 0;
  let endY = 0;
  let offset = 0;
  let page = false;

  /** Scroll axis */
  const axis = getAxisValue(trigger);

  /** @type {"width" | "height"} */
  const dimension = axis === "x" ? "width" : "height";

  /** Element bounds */
  const bounds = /** @type {BoundsProps} */ (main.bounds);

  offset = /** @type {Number} */ (bounds.get("offset-top"));
  startY = getCoordsStartEnd(trigger, "start", "y");
  endY = getCoordsStartEnd(trigger, "end", "y");

  return getScrollDefaultPercents(page, startY, endY, dimension, offset);
};

export default getScrollDefault;
